<template>
    <div>
        <div class="top-bar com-model m-b-15">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/index/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index/home/notice' }">公告通知</el-breadcrumb-item>
                <el-breadcrumb-item>公告详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="notice-cont com-model">
            <div class="notice-title">{{notice.title}}</div>
            <div class="flex m-b-24">
                <div>
                    <div class="pub-name">{{notice.publishUsername}}</div>
                    <div class="pub-time">{{notice.createdAt}}</div>
                </div>
            </div>
            <div class="notice-content">{{notice.content}}</div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            notice: {}
        }
    },
    created () {
        this.getNotice()
    },
    methods: {
        getNotice () {
            sessionStorage.getItem('noticeDetail') ? this.notice = JSON.parse(sessionStorage.getItem('noticeDetail')) : this.notice = {}
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.top-bar {
    padding: 22px 24px;
    line-height: 30px;
}
.com-model {
    border-radius: 10px;
}
.notice-cont {
    padding: 12px 25px 40px;
    .notice-title{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
        line-height: 28px;
        margin-bottom: 25px;
    }
    .pub-name{
        font-size: 14px;
        font-weight: 400;
        color: #555555;
        line-height: 20px;
        margin-bottom: 4px;
    }
    .pub-time{
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
    }
    .notice-content{
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
    }
}
</style>



// WEBPACK FOOTER //
// detail.vue?2e50edc8